<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import SettingsSectionLayout from '../components/SettingsSectionLayout.vue';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();
const route = useRoute();
const { accountScopedRoute } = useAccount();

const hideProfileInnerNav = computed(() =>
  route.matched.some(record => record.meta.hideProfileInnerNav === true)
);

const items = computed(() => [
  {
    name: 'profile_settings_index',
    label: t('PROFILE_SETTINGS.NAV.PROFILE'),
    icon: 'i-lucide-user-circle',
    to: accountScopedRoute('profile_settings_index'),
  },
  {
    name: 'profile_settings_notifications',
    label: t('PROFILE_SETTINGS.NAV.NOTIFICATIONS'),
    icon: 'i-lucide-bell',
    to: accountScopedRoute('profile_settings_notifications'),
  },
]);
</script>

<template>
  <SettingsSectionLayout
    :title="t('PROFILE_SETTINGS.NAV.HEADER')"
    :aria-label="t('PROFILE_SETTINGS.NAV.HEADER')"
    :items="items"
    :show-nav="!hideProfileInnerNav"
  >
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
      <component :is="Component" v-else :key="route.fullPath" />
    </router-view>
  </SettingsSectionLayout>
</template>
